(async () => {
    if (!customElements.get("loop-book")) {
        class loopbook extends HTMLElement {
            constructor() {
                super();
                this.swiperElement = this.querySelector("[data-swiper-loop-book]");
                this.swiperOptions = {
                    loop: false,
                    autoplay: false,
                    slidesPerView: 1,
                    direction: "horizontal",
                    observer: false,
                    resizeEvent: "auto",
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 15
                        },
                        768: {
                            slidesPerView: 1,
                            spaceBetween: 20
                        },
                        1024: {
                            slidesPerView: 3.5,
                            spaceBetween: 20
                        },
                        1440: {
                            slidesPerView: 4.5,
                            spaceBetween: 20
                        }
                    }
                };
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions
                        }
                    }
                }
                if (Shopify.designMode && this.swiperInstance) {
                    window.addEventListener("shopify:section:load", (() => {
                        this.swiperInstance.update()
                    }))
                }
                this.init()
            }
            init() {
                this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions)
            }
        }
        window.loopbook = loopbook;
        customElements.define("loop-book", loopbook)
    }
})();
